import { KeyValue } from '@/main/models/common';
import { ClaimTypeTypes, ClaimTypeActionTypes } from './claimTypeTypes';

export function getClaimType(): ClaimTypeActionTypes {
  return {
    type: ClaimTypeTypes.GET_CLAIM_TYPE
  };
}

export function saveClaimType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): ClaimTypeActionTypes {
  return {
    type: ClaimTypeTypes.SAVE_CLAIM_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerClaimType(): ClaimTypeActionTypes {
  return {
    type: ClaimTypeTypes.RESET_REDUCER_CLAIM_TYPE
  };
}

